// @flow

import OrderSearchStore from "shared/stores/OrderSearchStore"
import { injectIntl } from "react-intl"
import { observer } from "mobx-react-lite"
import React from "react"
import styled from "styled-components"
import { Rate } from "antd"
import { get } from "lodash"
import IntlStore from "shared/stores/IntlStore"
import moment from "moment"

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  margin: -5px 0;
`

const Element = styled.div`
  margin: 5px 0;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`

const Comment = styled.div`
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`

const CategoryDiv = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
`

const CategoryRectangle = styled.div`
  border-radius: 10px;
  background-color: #e7e7e7;
  padding: 3px 8px;
  display: flex;
  align-items: center;
  margin-right: 5px;
`

const CategoryText = styled.div`
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
`

const CreateText = styled.div`
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #989898;
`

const RatingPanel = props => {
  const {
    intl: { formatMessage }
  } = props

  const { rating } = OrderSearchStore.detailedOrder
  const currentLocale = IntlStore.locale.name

  const renderCategories = () => {
    const categories = get(rating, "categories", [])
    return (
      <Element>
        <CategoryDiv>
          {categories.map((category, index) => (
            <CategoryRectangle key={index}>
              <CategoryText>
                {get(category, "name." + currentLocale)}
              </CategoryText>
            </CategoryRectangle>
          ))}
        </CategoryDiv>
      </Element>
    )
  }

  const renderComment = () => {
    const comment = get(rating, "comment")
    return (
      comment && (
        <Element>
          <Comment>{get(rating, "comment", "-")}</Comment>
        </Element>
      )
    )
  }

  return (
    <Wrapper>
      <Element>
        <Title>{formatMessage({ id: "common.rating" })}</Title>
      </Element>
      <Element>
        <Rate allowHalf disabled value={get(rating, "rating", "-")} />
      </Element>
      {renderCategories()}
      {renderComment()}
      <Element>
        <CreateText>
          {moment(get(rating, "created")).format("YYYY-MM-DD HH:mm")}
        </CreateText>
      </Element>
    </Wrapper>
  )
}

export default (injectIntl(observer(RatingPanel)): any)
